/** Marque John Saks — symbole (lèvres + sucette). */
export function BrandMark({
  size = 40,
  variant = 'tile',
}: {
  size?: number
  variant?: 'tile' | 'plain'
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      aria-hidden="true"
      className="shrink-0"
    >
      {variant === 'tile' ? <rect width="200" height="200" rx="46" fill="#0E0B0C" /> : null}
      <g transform="translate(100,100) scale(0.70) translate(-99.5,-142.5)">
        <circle cx="100" cy="112" r="34" fill="#F04A63" />
        <ellipse
          cx="83"
          cy="100"
          rx="10"
          ry="6"
          fill="#FFF"
          opacity="0.9"
          transform="rotate(-28 83 100)"
        />
        <path
          d="M12,104 C28,74 46,60 64,66 C80,71 90,72 100,80 C110,72 120,71 136,66 C154,60 172,74 188,104 C168,92 136,86 100,92 C64,86 32,92 12,104 Z"
          fill="#D6183C"
        />
        <path
          d="M12,104 C40,124 70,134 100,134 C130,134 160,124 188,104 C178,158 144,190 100,190 C56,190 22,158 12,104 Z"
          fill="#D6183C"
        />
        <line
          x1="110"
          y1="134"
          x2="176"
          y2="214"
          stroke="#FFF6F2"
          strokeWidth="15"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}

export function BrandWordmark({
  className = 'font-titre text-[1.35rem] tracking-tight text-encre',
}: {
  className?: string
}) {
  return <span className={className}>John Saks</span>
}
